import React, { Component } from 'react'
import { Link } from "gatsby"
import { graphql } from 'gatsby'

import Layout from "./layout"
import Image from "./image"
import SEO from "./seo"

export default class projectsLayout extends Component {
    render() {
        const { markdownRemark } = this.props.data;
        
        return (
            <Layout>
              <div class="content-wrap">
                <div className="container employee-layout">
                <section class="section">

                  <h1 class="title"><Link to="/about" className="go-back">&#8249; Um okkur</Link></h1>
                  

                  <div class="columns is-multiline">
                    <div class="column is-one-third">
                      <div class="staff-box">
                        <p class="title is-1 one-employee-title">{markdownRemark.frontmatter.nafn}</p>
                        <img class="employee-image one-employee" src={markdownRemark.frontmatter.image.childImageSharp.fluid.src} alt="Placeholder image"></img>

                        <br></br>
                        <strong>Starfsvið:</strong>
                        <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.starfsvid}</p>

                        <strong>Póstur:</strong>
                        <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.postur}</p>

                        <strong>Sími:</strong>
                        <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.simi}</p>
                      </div>
                    </div>
                    <div class="column">
                      <div class="staff-box">
                        <p class="subtitle is-6" id="projects" dangerouslySetInnerHTML={{
                            __html: markdownRemark.html
                        }} ></p>
                      </div>
                    </div>
                  </div>
                </section>

                
                  {/* <h1 class="title"><Link to="/about" className="go-back">&#8249; Um okkur</Link></h1>
                    


                      <p class="title is-1 one-employee-title">{markdownRemark.frontmatter.nafn}</p>

                      <div className="box">
                        <div class="columns is-multiline">
                          <div class="column is-one-third">
                            <img class="employee-image one-employee" src={markdownRemark.frontmatter.image.childImageSharp.fluid.src} alt="Placeholder image"></img>

                            <br></br>
                            <strong>Starfsvið:</strong>
                            <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.starfsvid}</p>

                            <strong>Póstur:</strong>
                            <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.postur}</p>

                            <strong>Sími:</strong>
                            <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.simi}</p>
                          </div>
                        </div>
                        <div className="box">

                            <div class="column">
                              <p class="subtitle is-6" id="projects" dangerouslySetInnerHTML={{
                                  __html: markdownRemark.html
                              }} ></p>
                            </div>
                          </div>
                      </div>
                    <br></br>
                    <br></br> */}



                      {/* <p class="title is-1">{markdownRemark.frontmatter.nafn}</p>
                      <img class="employee-image" src={markdownRemark.frontmatter.image.childImageSharp.fluid.src} alt="Placeholder image"></img>

                      <br></br>
                      <strong>Starfsvið:</strong>
                      <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.starfsvid}</p>

                      <strong>Póstur:</strong>
                      <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.postur}</p>

                      <strong>Sími:</strong>
                      <p class="subtitle is-6" id="projects">{markdownRemark.frontmatter.simi}</p>
                      <p class="subtitle is-6" id="projects" dangerouslySetInnerHTML={{
                            __html: markdownRemark.html
                        }} ></p>
                        <br></br>
                        <br></br> */}
      
                </div>
              </div>
            </Layout>
        )
    }
}

export const query = graphql`
query EmployeeQuery($slug: String!){
    markdownRemark(frontmatter: {
      path: {
        eq: $slug
      }
    }) {
      html
      frontmatter{
        nafn
        starfsvid
        postur
        simi
        image{
          childImageSharp {
            fluid(maxWidth: 700) {
              src
            }
          }
        }
      }
    }
  }
`